import { PayloadAction } from '@reduxjs/toolkit'
import { Status } from '../../types'
import { DetailsData, CampaignState, CampaignListData } from './types'
import { Campaign } from '../../../api/campaign/types'

export const updateStatus = (state: DetailsData, status: Status) => {
	state.status = status
}

export const resetDetailsData = (state: CampaignState) => {
	state.detailsData.data = null
	state.detailsData.status = Status.IDLE
}

export const saveDetailsData = (state: CampaignState, action: PayloadAction<Campaign>) => {
	state.detailsData.data = action.payload
	state.detailsData.status = Status.IDLE
}

export const updateDetailsData = (state: CampaignState, action: PayloadAction<Partial<Campaign>>) => {
	updateStatus(state.detailsData, Status.IDLE)
	if (state.detailsData.data) {
		state.detailsData.data = {
			...state.detailsData.data,
			...action.payload,
		}
	}
}

export const updateListStatus = (state: CampaignListData, status: Status) => {
	state.status = status
}

export const saveListData = (
	state: CampaignState,
	action: PayloadAction<{
		campaigns: Campaign[]
		current_page: number
		total_pages: number
		total_records: number
	}>,
) => {
	state.listData.data = action.payload.campaigns
	state.listData.pagination = {
		currentPage: action.payload.current_page,
		totalPages: action.payload.total_pages,
		totalRecords: action.payload.total_records,
	}
	state.listData.status = Status.IDLE
}

export const removeCampaignFromList = (state: CampaignState, action: PayloadAction<string>) => {
	// Remove campaign by campaign_id from listData.data
	state.listData.data = state.listData.data.filter((campaign) => campaign.campaign_id !== action.payload)
	// Optionally update pagination totalRecords
	if (state.listData.pagination) {
		state.listData.pagination.totalRecords = Math.max(0, state.listData.pagination.totalRecords - 1)
	}
}

export const updateCampaignName = (
	state: CampaignState,
	action: PayloadAction<Campaign, string, { arg: { campaignId: string; updates: any } }>,
) => {
	const campaign = state.listData.data.find((campaign) => campaign.campaign_id === action.meta.arg.campaignId)
	if (campaign) {
		campaign.campaign_name = action.payload.campaign_name
	}
}
